import { takeLatest, call, put, all } from 'redux-saga/effects';
import { apiRequest } from '../services/apiService';

const baseUrl =
  'REACT_APP_BASE_URL' in process.env ? process.env.REACT_APP_BASE_URL : `http://${window.location.hostname}:3000/`;
const mlmApi = 'REACT_APP_MLM_API' in process.env ? process.env.REACT_APP_MLM_API : '/en/gb/';

export function* inputsWorkerSaga() {
  const requestType = 'GET';
  const url = new URL(`${mlmApi}inputs/inputs.json`, baseUrl);
  try {
    const response = yield call(apiRequest, requestType, url.href);
    const { data } = response;

    yield put({ type: 'GET_MLM_INPUTS_SUCCESS', data });
  } catch (error) {
    yield put({ type: 'GET_MLM_INPUTS_FAILURE', error });
  }
}

export function* outcomesWorkerSaga() {
  const requestType = 'GET';
  const url = new URL(`${mlmApi}outcomes/outcomes.json`, baseUrl);
  try {
    const response = yield call(apiRequest, requestType, url.href);
    const { data } = response;

    yield put({ type: 'GET_MLM_OUTCOMES_SUCCESS', data });
  } catch (error) {
    yield put({ type: 'GET_MLM_OUTCOMES_FAILURE', error });
  }
}

const questionnaireSagas = [
  takeLatest('GET_MLM_INPUTS_REQUEST', inputsWorkerSaga),
  takeLatest('GET_MLM_OUTCOMES_REQUEST', outcomesWorkerSaga)
];

export function* rootSaga() {
  yield all([...questionnaireSagas]);
}
